<template>
    <div class="index-type">
        <div v-if="promotionType == 1 || promotionType == 2">
            <div class="type-group">
                <div class="group-item">
                    <van-radio-group class="radio" v-model="value" direction="horizontal">
                        <van-radio :name="1">
                            <div class="group-content">
                            <p class="title">吊牌价满折活动</p>
                            <p class="desc">按吊牌价计算折扣</p>
                            </div>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
                            </template>
                        </van-radio>
                        <van-radio :name="2">
                            <div class="group-content">
                            <p class="title">折上折活动</p>
                            <p class="desc">按销售价计算折扣，折后价再满折</p>
                            </div>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="type-cnt">
                <p>什么是吊牌价满折，什么是折上折？</p>
                <img src="https://img.chinabeego.com/uploadfile/2022/8/25/16614194881931924737908182318.png"/>
            </div>
        </div>
        <div v-else>
            <div class="type-group">
                <div class="group-item">
                    <van-radio-group class="radio" v-model="value" direction="horizontal">
                        <van-radio :name="1">
                            <div class="group-content">
                                <p class="title">吊牌价满减活动</p>
                                <p class="desc">按吊牌价计算满减</p>
                            </div>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
                            </template>
                        </van-radio>
                        <van-radio :name="2">
                            <div class="group-content">
                                <p class="title">销售价满减活动</p>
                                <p class="desc">按销售价计算折扣，折后价再满减</p>
                            </div>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="type-cnt">
                <p>什么是吊牌价满减，什么是销售价满减？</p>
                <img src="https://img.chinabeego.com/uploadfile/2022/8/25/16614196964681926687075690057.png"/>
            </div>
        </div>
        <FixedBtn label="保存" @btnClick="onBtnClick"></FixedBtn>
    </div>
</template>

<script>
import FixedBtn from './components/fixed_btn';
import utils from "@/utils/common";
export default {
    data() {
        return {
            value: this.$route.query.discountType || 2,
            promotionType:this.$route.query.promotionType || 1
        }
    },
    created() {
        this.$loading.hide()
    },
    methods: {
        onBtnClick() {
            this.$store.dispatch('saveDiscountKey', { key: 'discountType', val: this.value})
            utils.goBack()
        }
    },
    components: {
        FixedBtn
    }
}
</script>

<style lang="less" scoped>
.index-type {
    .type-group {
        height: 150px;
        padding: 30px 0 37px 0;
        padding-left: 28px;
        display: flex;
        box-sizing: border-box;
        background-color: #fff;
        margin: 10px 0;
            
       
        .group-item {
            .img-icon {
                width: 40px;
                height: 40px;
            }
            .group-content {
                position: relative;
                margin-left: 4px;
                .title {
                    font-size: 28px;
                    line-height: 40px;
                    font-weight: 500;
                    margin-bottom: 10px;
                }

                .desc {
                    font-size: 24px;
                    color: #999;
                    line-height: 33px;
                }
            }
            /deep/.van-radio--horizontal {
                margin-right: 25px;
            }
        }
    }
    .type-cnt {
        height: 735px;
        padding: 40px 40px 43px;
        font-size: 28px;
        font-weight: 500;
        text-align: center;
        background-color: #fff;
        box-sizing: border-box;

        p {
            height: 40px;
            line-height: 40px;
        }

        img {
            width: 670px;
            height: 582px;
            margin-top: 30px;
        }
    }
}
</style>